<style>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.total-rows {
  padding: 10px;
  font-weight: bold;
}
</style>
<script setup>
import * as XLSX from "xlsx";
import CustomComboBox from "@/components/Custom_DDL_Checkbox.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Baja Report</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Block ID</label>
                            <CustomComboBox :list="blockidList" v-model="search.blockid"/>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Date From</label>
                            <input type="date" id="input_date" v-model="search.datefrom" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Date To</label>
                            <input type="date" id="input_date" v-model="search.dateto" class="form-control" >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="bajaReport" style="float: right;margin: 5px;" id="btn_search">Search</button>
                            <button class="btn btn-primary " @click="exportBajaReport" style="float: right;margin: 5px;" id="btn_export">Export</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                    <h6>Baja List (Luar)</h6>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                    <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                        <thead>
                        <tr>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Block
                            </th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                            Item
                            </th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                            Quantity (Beg)
                            </th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                            Date
                            </th>
                            <!-- <th class="text-secondary opacity-7"></th> -->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in paginatedBajaReport" :key="index">
                            <td>
                            <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ item.location }}</h6>
                                </div>
                            </div>
                            </td>
                            <td>
                            <h6 class="text-xs font-weight-bold mb-0">{{ item.item }}</h6>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ item.total_quantity }} Beg</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ item.date }}</p>
                            </td>
                        </tr>
                        
                        </tbody>
                    </table>
                    <!-- Pagination Controls -->
                    <hr />
                    <div class="pagination-container">
                        <div>
                        <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
                        <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
                        <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
                        </div>
                        
                        <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
                    </div>
                    </div>
                </div>
                </div>
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'bajaReport',
  data(){
    return {
        search:{
            datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
            dateto: new Date().toISOString().slice(0,10),
            blockid:''
        },
        totalRows:0,
        currentPage: 0,
        perPage: 20,
        blockidList:[],
        bajaList:[]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.bajaList.length / this.perPage);
    },
    paginatedBajaReport() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.bajaList.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getBlockList();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getBlockList(){
        axios.get('block/getBlockidList')
            .then(res => {
                //this.blockidList = res.data.blockidList;
                //this.search.blockid = res.data.blockidList[0].blockid;
                res.data.blockidList.forEach(element => {
                var blockObj = {
                    "text": element.blockid, "value":element.blockname
                }
                this.blockidList.push(blockObj);
                
              });
                // console.log(this.model.lorryservicestype);
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    bajaReport(){
      var blockid = '%';
        if(this.search.blockid != ''){
            blockid = this.search.blockid;
        }
        axios.get('stock/listBajaReport/'+ this.search.datefrom + "/" + this.search.dateto + "/" + blockid)
            .then(res => {
                this.bajaList = res.data.bajaReport;
                this.currentPage = 1;
                this.totalRows = res.data.bajaReport.length;
            }).catch(function (error){
                if(error.response){
                    console.log(error.response);
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    exportBajaReport(){
        var blockid = '%';
        if(this.search.blockid != ''){
            blockid = this.search.blockid;
        }
        axios.get('stock/exportBajaReport/'+ this.search.datefrom + "/" + this.search.dateto + "/" + blockid)
            .then(res => {
                let exportList = res.data.bajaReport;
                // 1. Ensure data is sorted by blockid to keep groups together
                const sortedData = [...exportList].sort((a, b) => a.blockid.localeCompare(b.blockid));
                
                // 2. Define the column widths
                // Index 0: blockid, 1: blockname, 2: month_date, 3: details
                const wscols = [
                    { wch: 10 }, // Column A (blockid)
                    { wch: 20 }, // Column B (blockname)
                    { wch: 15 }, // Column C (month_date)
                    { wch: 40 }, // Column D (details) - usually wider for dates/quantities
                ];

                // 2. Convert JSON to worksheet
                const worksheet = XLSX.utils.json_to_sheet(sortedData);
                const merges = [];

                let startRow = 1; // Row 0 is the header

                for (let i = 0; i < sortedData.length; i++) {
                    const current = sortedData[i];
                    const next = sortedData[i + 1];

                    // Check ONLY blockid for the merge trigger
                    if (!next || current.blockid !== next.blockid) {
                    
                    // If the group has more than one row, define the merge range
                    if (startRow < i + 1) {
                        // Merge Column A (blockid) - Index 0
                        merges.push({ 
                            s: { r: startRow, c: 0 }, 
                            e: { r: i + 1, c: 0 } 
                        });
                        
                        // Merge Column B (blockname) - Index 1
                        merges.push({ 
                            s: { r: startRow, c: 1 }, 
                            e: { r: i + 1, c: 1 } 
                        });
                    }
                    
                    startRow = i + 2; // Reset for the next block group
                    }
                }
                worksheet['!cols'] = wscols;
                // 3. Apply merges to the worksheet
                worksheet['!merges'] = merges;

                // 4. Generate and download file
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Baja Report");
                XLSX.writeFile(workbook, `Baja_Report_${this.search.datefrom}_${this.search.dateto}.xlsx`);
            }).catch(function (error){
                if(error.response){
                    console.log(error.response);
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>